import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatNumber } from '../../utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => {
      if (typeof Header === 'object') {
        return Header.props?.children || Header;
      }
      return Header;
    });
  const rows = [];
  data.forEach(({ name, buildingsCount, monthlyBill }) => {
    rows.push([
      name,
      String(buildingsCount),
      monthlyBill && `$${formatNumber(monthlyBill)}`,
    ]);
  });
  return { headers, rows };
};

const PMCListExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default PMCListExport;
